<template>
  <!-- Main Footer -->
  <footer class="main-footer">
    <strong>Copyright &copy; 2024 <a href="https://grupoapuyen.com" target="_blank">Grupo Apuyen</a>.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 6.0.0.beta
    </div>
  </footer>
</template>